import { useCallback } from "react";
import { useSearchParams } from "react-router";

export type DashboardTab = "investments" | "bookings";

export const useActiveTabParam = (): [
  DashboardTab,
  (tab: DashboardTab) => void,
] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = (searchParams.get("tab") ?? "investments") as DashboardTab;

  const setActiveTab = useCallback(
    (tab: DashboardTab) => {
      setSearchParams(
        (prev) => {
          prev.set("tab", tab);
          return prev;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  return [activeTab, setActiveTab];
};
